import Axios from 'axios'
import { BE_DOMAIN } from '../env'
import { STATUS_CODE } from '../data/system_settings'

export class baseService {
  // Lấy lại accessToken từ localStorage
  getAccessToken = () => {
    const root = JSON.parse(localStorage.getItem('persist:root') || '{}')
    const auth = root?.auth ? JSON.parse(root.auth) : null
    return auth?.data?.user?.accessToken || ''
  }

  put = async (url, model) => {
    try {
      const accessToken = this.getAccessToken()
      const response = await Axios({
        url: `${BE_DOMAIN}/${url}`,
        method: 'PUT',
        data: model,
        headers: { Authorization: accessToken ? 'Bearer ' + accessToken : '' }, // JWT
      })
      return response
    } catch (error) {
      throw error
    }
  }

  post = async (url, model) => {
    try {
      const accessToken = this.getAccessToken()
      const response = await Axios({
        url: `${BE_DOMAIN}/${url}`,
        method: 'POST',
        data: model ?? {},
        headers: { Authorization: accessToken ? 'Bearer ' + accessToken : '' }, // JWT
      })
      return response
    } catch (error) {
      console.log('Error', error)
      throw error
    }
  }

  postPublic = async (url, model) => {
    try {
      const response = await Axios({
        url: `${BE_DOMAIN}/${url}`,
        method: 'POST',
        data: model,
      })
      return response
    } catch (error) {
      throw error
    }
  }

  get = async (url, model, inAccessToken) => {
    try {
      const accessToken = inAccessToken ? inAccessToken : this.getAccessToken()
      const response = await Axios({
        url: `${BE_DOMAIN}/${url}`,
        method: 'GET',
        headers: { Authorization: accessToken ? 'Bearer ' + accessToken : '' }, // JWT
        params: model,
      })
      return response
    } catch (error) {
      throw error
    }
  }

  getPublic = async (url, model) => {
    try {
      const response = await Axios({
        url: `${BE_DOMAIN}/${url}`,
        method: 'GET',
        params: model,
      })
      return response
    } catch (error) {
      throw error
    }
  }

  delete = async (url) => {
    try {
      const accessToken = this.getAccessToken()
      const response = await Axios({
        url: `${BE_DOMAIN}/${url}`,
        method: 'DELETE',
        headers: { Authorization: accessToken ? 'Bearer ' + accessToken : '' }, // JWT
      })
      return response
    } catch (error) {
      throw error
    }
  }
  deleteWithBody = async (url, body) => {
    try {
      const accessToken = this.getAccessToken()
      const response = await Axios({
        url: `${BE_DOMAIN}/${url}`,
        method: 'DELETE',
        data: body ?? {},
        headers: { Authorization: accessToken ? 'Bearer ' + accessToken : '' }, // JWT
      })
      return response
    } catch (error) {
      throw error
    }
  }

  uploadFile = async (url, file) => {
    try {
      const formData = new FormData()
      formData.append('file', file)

      const response = await Axios({
        url: `${url}`,
        method: 'PUT',
        data: file,
        headers: {
          'Content-Type': file.type || 'application/octet-stream',
        },
      })
      return response
    } catch (error) {
      throw error
    }
  }
}

// refactoring inprogress
// import Axios from 'axios'
// import { BE_DOMAIN } from '../env'

// export class baseService {
//   constructor() {
//     this.axiosInstance = Axios.create({
//       baseURL: BE_DOMAIN,
//     })

//     // Intercept responses to handle errors globally
//     this.axiosInstance.interceptors.response.use(
//       (response) => response,
//       (error) => {
//         if (error.response && error.response.status === 403) {
//           // Clear localStorage on 403 error
//           localStorage.clear()
//           console.error('Error 403: User session has been cleared.')
//         }
//         return Promise.reject(error)
//       }
//     )
//   }

//   // Get the access token from localStorage
//   getAccessToken = () => {
//     const root = JSON.parse(localStorage.getItem('persist:root') || '{}')
//     const auth = root?.auth ? JSON.parse(root.auth) : null
//     return auth?.data?.user?.accessToken || ''
//   }

//   // PUT request
//   put = (url, model) => {
//     const accessToken = this.getAccessToken()
//     return this.axiosInstance.put(url, model, {
//       headers: { Authorization: accessToken ? `Bearer ${accessToken}` : '' },
//     })
//   }

//   // POST request
//   post = (url, model) => {
//     const accessToken = this.getAccessToken()
//     return this.axiosInstance.post(url, model ?? {}, {
//       headers: { Authorization: accessToken ? `Bearer ${accessToken}` : '' },
//     })
//   }

//   // Public POST request
//   postPublic = (url, model) => {
//     return this.axiosInstance.post(url, model)
//   }

//   // GET request
//   get = (url, model, inAccessToken) => {
//     const accessToken = inAccessToken || this.getAccessToken()
//     return this.axiosInstance.get(url, {
//       headers: { Authorization: accessToken ? `Bearer ${accessToken}` : '' },
//       params: model,
//     })
//   }

//   // Public GET request
//   getPublic = (url, model) => {
//     return this.axiosInstance.get(url, { params: model })
//   }

//   // DELETE request
//   delete = (url) => {
//     const accessToken = this.getAccessToken()
//     return this.axiosInstance.delete(url, {
//       headers: { Authorization: accessToken ? `Bearer ${accessToken}` : '' },
//     })
//   }
// }
